import "./index.scss";
import React from "react";
import { Timeline, Typography, Space } from "antd";

const { Text } = Typography;

export interface AuditItem {
  id: string;
  action: string; // e.g., "Updated"
  changes: { field: string; from: string; to: string }[];
  oldData?: Record<string, any>;
  newData?: Record<string, any>;
  updatedAt: string; // e.g., "5 mins ago"
  user: string; // e.g., "Amanda"
}

interface AuditTrailProps {
  items: AuditItem[];
  transformItemDisplay?: (item: AuditItem, change: { field: string; from: string; to: string }) => React.ReactNode;
}

const AuditTrail: React.FC<AuditTrailProps> = ({ items, transformItemDisplay }) => {
  const timelineItems = items.map((item) => ({
    key: item.id,
    children: (
      <Space direction="vertical" size={4} style={{ paddingLeft: 8 }}>
        <Text strong>{item.action}</Text>

        {item.changes.map((change, i) => (
          <div key={`${item.id}-${i}`} className="change-line">
            {transformItemDisplay?.(item, change) ?? (
              <>
                <Text strong>{change.field}</Text>{" "}
                <Text type="secondary">
                  from {change.from || "blank"} to {change.to || "blank"}
                </Text>
              </>
            )}
          </div>
        ))}

        <div className="audit-meta">
          {item.updatedAt} - by {item.user}
        </div>
      </Space>
    ),
  }));

  return <Timeline className="custom-timeline" items={timelineItems} />;
};

export default AuditTrail;
